










































































import { Component } from "vue-property-decorator";
import AbstractScene from "@/components/AbstractScene.vue";
import ResultSceneBackground from "@/components/ResultSceneBackground.vue";
import PlusOneComponent from "@/components/PlusOneComponent.vue";
import NewComponent from "@/components/NewComponent.vue";

@Component({
  components: {
    ResultSceneBackground,
    PlusOneComponent,
    NewComponent,
  },
})
export default class ResultScene extends AbstractScene {
  clickToDone = true;
  tdStyle(i: number): { background: string } {
    return {
      background: `url(${this.result[i].pictureurl}) center center / contain no-repeat`,
    };
  }
}
